import { useEffect } from 'react';
import { ff } from '@atlassian/jira-feature-flagging';
import { useBulkChangePermissionService } from '../../services/bulk-change-permission';
import { useBulkSelectionStore } from '../bulk-selection';

export const useBulkChangePermission: () => boolean | undefined = () => {
	if (!ff('bulk-edit-in-jwm-list-view_bny2w')) return false;

	// eslint-disable-next-line react-hooks/rules-of-hooks
	const [, { setBulkChangePermission }] = useBulkSelectionStore();

	// eslint-disable-next-line react-hooks/rules-of-hooks
	const bulkChangePermission = useBulkChangePermissionService();

	// eslint-disable-next-line react-hooks/rules-of-hooks
	useEffect(() => {
		bulkChangePermission !== null &&
			bulkChangePermission !== undefined &&
			setBulkChangePermission({ bulkChangePermission });
	}, [bulkChangePermission, setBulkChangePermission]);

	return bulkChangePermission;
};
